<template>
  <main class="absolute inset-0 grid grid-cols-1 overflow-y-auto"
        :class="typeformData.hasLeft ? 'lg:grid-cols-2' : 'lg:grid-cols-1'">

    <nav class="absolute inset-x-0 top-0 z-50">
      <TypeformProgress v-if="currentStep && totalSteps"
                        :currentStep="currentStep"
                        :totalSteps="totalSteps"/>

      <div class="p-2 absolute top-0 left-0 rounded-br-4xl"
           :style="primary">
        <div class="rounded-full p-0.5" :class="typeformData.avatar && 'bg-white'">
          <div class="rounded-full" :style="primary">
            <UtilityProfileInitials
              :avatar="typeformData.avatar"
              :name="typeformData.name"
              bg-class="bg-transparent"
              color-class="text-transparent"
              :bg-styles="`background-color:${addOpacityToHex(typeformData.primaryForeground, 0.1)};`"
              :color-style="`color:${typeformData.primaryForeground};`"
              size="md"/>
          </div>
        </div>
      </div>
    </nav>

    <TransitionFade>
      <div v-if="typeformData.hasLeft" class="hidden lg:block">
        <Component v-if="typeformData.leftComponent" :is="typeformData.leftComponent"/>

        <div v-else class="relative flex items-center justify-center">
          <img v-if="typeformData.imageLeft" :src="typeformData.imageLeft" :alt="typeformData.name"
               class="object-cover w-full h-full"/>
        </div>

      </div>
    </TransitionFade>

    <div class="w-full h-full relative z-0 overflow-hidden" :style="primary">

      <div v-if="typeformData.logo && typeformLogoHasTransparency"
           class="pointer-events-none absolute inset-0 -z-10 h-full w-full object-cover object-center opacity-5">
        <div class="h-96 w-96 rotate-[24deg] xl:scale-[2] absolute -bottom-44 lg:-bottom-8 -left-8">
          <img :src="typeformData.logo" :alt="typeformData.name"
               class="object-contain w-full h-full brightness-0 invert" :class="animateClass"
               style="--from-transform-y:0;--anim-delay:0.5s;--anim-duration:1000ms;"/>
        </div>
        <div class="h-96 w-96 rotate-[-14deg] absolute -top-56 lg:-top-28 xl:scale-150 -right-4">
          <img :src="typeformData.logo" :alt="typeformData.name"
               class="object-contain w-full h-full brightness-0 invert" :class="animateClass"
               style="--from-transform-y:0;--anim-delay:0.4s;--anim-duration:1000ms;"/>
        </div>
        <div class="h-80 w-80 rotate-[12deg] absolute -bottom-64 xl:scale-110 -right-32">
          <img :src="typeformData.logo" :alt="typeformData.name"
               class="object-contain w-full h-full brightness-0 invert" :class="animateClass"
               style="--from-transform-y:0;--anim-delay:0.6s;--anim-duration:1000ms;"/>
        </div>
      </div>

      <slot/>
    </div>
  </main>
</template>

<script setup>
import TransitionFade from "./TransitionFade.vue";
import TypeformProgress from "./TypeformProgress.vue";
import {computed, inject, ref, watch} from "vue";
import {useAnimateInTrigger} from "../composables/AnimateInComposable";
import {hasTransparency} from "../helpers/ImageInfo";
import UtilityProfileInitials from "./UtilityProfileInitials.vue";
import {addOpacityToHex} from "../helpers/Color";

defineProps({
  currentStep: Number,
  totalSteps: Number,
});

const typeformData = inject("typeformData", {});

const animateClass = ref("animate-in-vars-pre");
const logoEl = ref(null);
const typeformLogoHasTransparency = ref(true);

useAnimateInTrigger(logoEl, (className) => animateClass.value = className);

watch(() => typeformData?.logo, (newVal, oldVal) => {
  if (newVal === oldVal || !newVal) return;
  hasTransparency(newVal, (hasTransparency) => typeformLogoHasTransparency.value = hasTransparency);
}, {immediate: true});

const primary = computed(() => `background: ${typeformData.primaryBackground}; color: ${typeformData.primaryForeground};`);
</script>
